import React from 'react';
import { useSelector } from 'react-redux';
import * as S from './styles';
import GridHistoricoRelatorioRequerimento from 'containers/Relatorios/ListarRequerimentos/Grid/GridHistoricoRelatorioRequerimento';

export const HistoricoRelatorioRequerimento = () => {
  const modalState = useSelector(state => state.app.modal);

  return (
    <S.HistoricoContainer>
      <GridHistoricoRelatorioRequerimento dadosGrid={modalState?.props?.dadosGrid} />
    </S.HistoricoContainer>
  );
};

export default HistoricoRelatorioRequerimento;
